export default __webpack_public_path__ + "static/media/EU.49c068fc.ico";